import { render, staticRenderFns } from "./FooterSec.vue?vue&type=template&id=6aceacf8&scoped=true&"
import script from "./FooterSec.vue?vue&type=script&lang=js&"
export * from "./FooterSec.vue?vue&type=script&lang=js&"
import style0 from "./FooterSec.vue?vue&type=style&index=0&id=6aceacf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aceacf8",
  null
  
)

export default component.exports